import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { toggleScheduleDays, toggleScheduleType } from "store/actions";

function Daily(props) {
  return (
    <React.Fragment>
      <div className="sche_backup_item daily random_schedule">
        <div className="idapp__schedule idapp-daily__schedule">
          <label className="idapp-form__label">Backup start days:</label>
          <div className="idapp-radiogrp-schedule idapp-dailygrp-schedule">
            <div className="idapp-radio__div">
              <label
                className="idapp-radio__label"
                htmlFor="bkp-daily-runeveryday"
              >
                <input
                  className="idapp-radio__input"
                  type="radio"
                  id="bkp-daily-runeveryday"
                  name="bkp-daily-freq"
                  checked={props.weekDays.length === 7}
                  onChange={() =>
                    props.toggleScheduleDays([1, 2, 3, 4, 5, 6, 0])
                  }
                />
                <span className="idapp-radio__checkmark"></span>
                <span className="idapp-radio__name">Run every day</span>
              </label>
            </div>
            <div className="idapp-radio__div">
              <label
                className="idapp-radio__label"
                htmlFor="bkp-daily-runmontofri"
              >
                <input
                  className="idapp-radio__input"
                  type="radio"
                  id="bkp-daily-runmontofri"
                  name="bkp-daily-freq"
                  checked={
                    props.weekDays.length === 5 &&
                    [1, 2, 3, 4, 5].every(day => props.weekDays.includes(day))
                  }
                  onChange={() => {
                    props.toggleScheduleType(props.enums.ScheduleType.CUSTOM);
                    props.toggleScheduleDays([1, 2, 3, 4, 5]);
                  }}
                />
                <span className="idapp-radio__checkmark"></span>
                <span className="idapp-radio__name">Run Monday to Friday</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    weekDays: state.backupSettings.scheduleInfo.weekDays,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleScheduleType,
      toggleScheduleDays
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Daily);
